import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractProductCategory from "../ProductCategory";

class ProductCategory extends AbstractProductCategory {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-category-ipr';
  }
}

export default ProductCategory;
